import React from 'react'
import { useDispatch } from 'react-redux'
import * as S from './ReceivementFinishFilters.styles'
import { useParams } from 'react-router-dom'
import { actions } from '../../ReceivementState'
import { ReceivementSearchInput } from '../ReceivementSearchInput'
import { useReceivement } from 'src/hooks/useReceivement'
import { useStore } from 'src/utils/store'

const ReceivementFinishFilters = () => {
  const dispatch = useDispatch()
  const store = useStore()
  const { receivementId } = useParams<{ receivementId?: string }>()
  const { operatorBadge } = useReceivement({ valideOperator: true })

  const getFinish = React.useCallback(async () => {
    if (!receivementId) return

    const { productDescription } = store.getState().receivement.overviewFilters

    dispatch(
      actions.getFinish({
        badge: operatorBadge,
        receivementId,
        productDescription,
      }),
    )
  }, [dispatch, operatorBadge, receivementId, store])

  React.useEffect(() => () => {
    dispatch(actions.clearOverviewFilters())
  }, [dispatch])

  const handleProductFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      actions.setProductDescriptionFilter({
        productDescription: e.target.value,
      }),
    )
  }

  const handleSearch = React.useCallback(() => {
    getFinish()
  }, [getFinish])

  return (
    <S.FiltersWrapper>
      <ReceivementSearchInput onChangeText={handleProductFilter} handleSearch={handleSearch}/>
    </S.FiltersWrapper>
  )
}

export { ReceivementFinishFilters }
